module.exports = __webpack_public_path__ + "static/image/history/m/201908@3x.jpg?5377cf22";